var $3f13373950080912$exports = {};
$3f13373950080912$exports = {
    "loading": `Notiek iel\u{101}de...`,
    "loadingMore": `Tiek iel\u{101}d\u{113}ts v\u{113}l...`
};


export {$3f13373950080912$exports as default};
//# sourceMappingURL=lv-LV.module.js.map
